export default __webpack_public_path__ + "images/wall_pvc_transparent_a7d3ed58a6669f2ef4f14e542fb30a35.png";